import { c as _c } from "react/compiler-runtime";
import { Tooltip, TooltipContent, TooltipTrigger } from '@/comps/primitives/tooltip';
import { cn } from '@/utils/shad';
import { Info } from 'lucide-react';
import type { ReactNode } from 'react';
type InfoTooltipProps = {
  content: ReactNode;
  /** Describes the tooltip target for screen readers (e.g. `Chart description`). */
  label: string;
  className?: string;
};

/** The (i) affordance used next to card titles and table column headers. */
export function InfoTooltip(t0) {
  const $ = _c(11);
  const {
    content,
    label,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("cursor-default p-1 text-muted-foreground outline-hidden focus-visible:ring-2 focus-visible:ring-ring", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Info className="size-3.5" strokeWidth={2} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label || $[4] !== t1) {
    t3 = <TooltipTrigger asChild={true}><button type="button" className={t1} aria-label={label} onClick={_temp}>{t2}</button></TooltipTrigger>;
    $[3] = label;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== content) {
    t4 = <TooltipContent side="bottom" align="start" className="max-w-xs text-left leading-snug">{content}</TooltipContent>;
    $[6] = content;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <Tooltip>{t3}{t4}</Tooltip>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(e) {
  return e.stopPropagation();
}